import React from "react";
import CurrentUserWorkflows from "./index";

let routes = [
    {
        path: "/current_user/workflows",
        component: CurrentUserWorkflows,
        name: "Current User Workflows",
    },
];

export default routes;
